<template>
  <div class="RoundChart" v-if="imgs.length > 1">
    <span class="left" @click="toleft"><i class="el-icon-arrow-left"></i></span>

    <div>
      <ul ref="ul">
        <li ref="li" :style="{borderColor: index === currentImgIndex ? '#909399' : '#e9e9eb'}" v-for="(img,index) in imgs"
            :key="index" @click="clickImg(index)"><img :src="img" alt=""></li>
      </ul>
    </div>

    <span class="right" @click="toright"><i class="el-icon-arrow-right"></i></span>
  </div>
</template>

<script>

export default {
  name: "RoundChart",
  props: ['imgs'],
  watch: {
    imgs: {
      immediate: true,
      handler(newValue) {
        this.$nextTick(function () {
          this.list = this.$refs.ul
          this.listElems = this.$refs.li
        })
      }
    }
  },
  data() {
    return {
      //当前的图片
      currentImgIndex: 0,
      width: 107,
      count: 4,
      position: 0,

      list: null,
      listElems: null
    }
  },
  methods: {
    clickImg(index) {
      this.currentImgIndex = index
      this.$emit('getimg', index)
    },
    toleft() {
      this.position += this.width * this.count;
      this.position = Math.min(this.position, 0)
      this.list.style.marginLeft = this.position + 'px';
    },
    toright() {
      if (this.imgs.length > 4) {
        this.position -= this.width * this.count;
        this.position = Math.max(this.position, -this.width * (this.listElems.length - this.count));
        this.list.style.marginLeft = this.position + 'px';
      }
    }
  }
}
</script>

<style scoped lang="scss">
.RoundChart {
  display: flex;
  justify-content: space-between;
  height: 100px;
  border: 1px solid #eee;

  div {
    height: 100%;
    overflow: hidden;
    flex: 1;
    ul {
      width: 9999px;
      height: 100%;
      padding: 5px 0;
      transition: .5s;

      li {
        width: 100px;
        height: 100%;
        margin: 0 4px;
        position: relative;
        border: 1px solid #e9e9eb;
        overflow: hidden;
        display: inline-block;

        img {
          width: 100%;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          cursor: pointer;
        }
      }

    }
  }

  .left, .right {
    display: inline-block;
    width: 20px;
    height: 100%;
    line-height: 6;
    background: #e9e9eb;
    cursor: pointer;
    transition: .3s;
  }

  .left:hover, .right:hover {
    background: #909399;
  }
}
</style>
